import { useEffect, useRef } from "react";

import type { LayerKey } from "../domain/types";
import { parseUrlState, serializeUrlState, typhoonAppStore } from "../state/appStore";

interface UrlSyncState {
  stormKey: string;
  selectedCityId: string | null;
  pinnedCityIds: string[];
  currentHour: number;
  hiddenLayers: LayerKey[];
}

function hydrateStoreFromLocation() {
  const parsed = parseUrlState(window.location.search);
  const params = new URLSearchParams(window.location.search);
  typhoonAppStore.getState().hydrateUrlState({
    stormKey: parsed.stormKey ?? undefined,
    selectedCityId: parsed.selectedCityId ?? undefined,
    pinnedCityIds: params.has("pins") ? parsed.pinnedCityIds : undefined,
    currentHour: parsed.currentHour,
    hiddenLayers: parsed.hiddenLayers,
  });
}

export function useUrlStateSync(state: UrlSyncState) {
  const hydrated = useRef(false);

  useEffect(() => {
    if (hydrated.current) return;
    hydrated.current = true;
    hydrateStoreFromLocation();
  }, []);

  useEffect(() => {
    if (!hydrated.current) return;
    const search = serializeUrlState({
      stormKey: state.stormKey,
      selectedCityId: state.selectedCityId,
      pinnedCityIds: state.pinnedCityIds,
      currentHour: state.currentHour,
      hiddenLayers: state.hiddenLayers,
    });
    const nextUrl = `${window.location.pathname}${search}${window.location.hash}`;
    window.history.replaceState(window.history.state, "", nextUrl);
  }, [state.currentHour, state.hiddenLayers, state.pinnedCityIds, state.selectedCityId, state.stormKey]);

  useEffect(() => {
    const restore = () => {
      hydrateStoreFromLocation();
    };
    window.addEventListener("popstate", restore);
    return () => window.removeEventListener("popstate", restore);
  }, []);
}
